import { Button } from "../../ui-components/Button";
import homebanner from "../../../assets/images/Images/Home-Images/image36.png";
import home1 from "../../../assets/images/Images/Home-Images/home_1.png";
import homebannerslider from "../../../assets/images/Images/Home-Images/home-bg-slider.svg";
import forst from "../../../assets/images/Images/Home-Images/forst.svg";

import { Link } from "react-router-dom";
import { useState } from "react";
type Props = {};

export default function LandingPageBanner(props: Props) {
  const [activetIndex, setActiveIndex] = useState(true);
  return (
    <>
      {/* Mobile View*/}
      <div className="d-block d-md-none">
        {activetIndex ? (
          <div
            style={{
              backgroundImage: `url(${home1})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className="py-60"
          >
            <div className={`container mt-60`}>
              <p
                className={`wp-53 line-28 fonts-400 font-24 my-20 text-white-color font-family-condensed"`}
              >
                Break Barriers and Optimize Operations with Yantr.ai
              </p>
              <p
                className={`font-family-roboto text-white-color fonts-400 wp-70 font-14 line-20`}
              >
                Smarter Supply Chain Operations and Seamless Field Services
              </p>
              <div className={`buttongroup`}>
                <div className="d-flex justify-content-start flex-gap-20 mt-24 wp-28">
                  <Link to={"/contact-us"}>
                    <Button
                      textclass="font-12 fonts-500 line-10 font-family-roboto-flex"
                      className="wx-107 hx-30 text-color-success radius-5 d-flex align-items-center text-align-center justifiy-content-center"
                      text="Book a Demo"
                    />
                  </Link>
                  <a
                    href="https://youtu.be/1rcfp5Xx-kY"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <Button
                      textclass="font-12 fonts-500 line-10  font-family-roboto-flex"
                      className="wx-107 hx-30 text-color-success radius-5"
                      text="Watch Video"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              backgroundImage: `url(${homebannerslider})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
            className="py-60"
          >
            <div className={`container`}>
              <div className="justify-content-center font-family-condensed text-center line-46 fonts-300 font-24 my-0 text-white-color">
                <img
                  className="justify-content-center text-center pb-10 w-100"
                  src={forst}
                  alt="forst"
                />
                <p
                  className={`wp-100 justify-content-center font-family-condensed text-center line-26 fonts-300 font-20 my-10 text-white-color`}
                >
                  Tech Mahindra Awarded Frost & Sullivan's 2023 Global Enabling
                  Technology Leadership Award for Its Innovative Cognitive AI
                  Field Service Management Solution.
                </p>
                <div className={`buttongroup`}>
                  <div className=" d-flex justify-content-center py-10">
                    <Button
                      textclass="font-12 fonts-500 justify-content-center line-19 font-family-roboto-flex"
                      className="wx-117 hx-35 text-color-success radius-5"
                      text="Download Report"
                      onClick={() =>
                        window.open(
                          "https://www.frost.com/wp-content/uploads/2023/11/TechMahindra-Award-Writeup.pdf"
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container d-flex justify-content-center flax-gap-5">
          <button
            onClick={() => setActiveIndex(!activetIndex)}
            className={
              activetIndex
                ? "active mt-n-30 p-1"
                : "banner-slider mt-n-30 ml-10 p-1"
            }
          ></button>
          <button
            onClick={() => setActiveIndex(!activetIndex)}
            className={
              activetIndex
                ? "banner-slider mt-n-30 ml-10 p-1"
                : "active mt-n-30 ml-10 p-1"
            }
          ></button>
        </div>
      </div>
      {/*Website View */}
      <div className="d-none d-md-block">
        {activetIndex ? (
          <div
            style={{
              backgroundImage: `url(${homebanner})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "500px",
            }}
            className="whyyantraiheader py-120"
          >
            <div className={`container mt-74`}>
              <p
                className={`wp-56 line-46 fonts-400 font-40 my-20 text-white-color font-family-condensed"`}
              >
                Break Barriers and Optimize Operations with Yantr.ai
              </p>
              <p
                className={`font-family-roboto text-white-color fonts-400 wp-35 font-20 line-32`}
              >
                Smarter Supply Chain Operations and Seamless Field Services
              </p>
              <div className={`buttongroup`}>
                <div className="d-flex justify-content-start flex-gap-20 mt-24 wp-28">
                  <Link to={"/contact-us"}>
                    <Button
                      textclass="font-16 fonts-500 line-19 p-17 font-family-roboto-flex"
                      className="wx-147 hx-40 text-color-success radius-5 d-flex align-items-center text-align-center justifiy-content-center"
                      text="Book a Demo"
                    />
                  </Link>
                  <a
                    href="https://youtu.be/1rcfp5Xx-kY"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <Button
                      textclass="font-16 fonts-500 line-19 pl-24 font-family-roboto-flex"
                      className="wx-147 hx-40 text-color-success radius-5"
                      text="Watch Video"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            style={{
              backgroundImage: `url(${homebannerslider})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: "500px",
            }}
            className="whyyantraiheader py-120"
          >
            <div className={`container`}>
              <div className="justify-content-center font-family-condensed text-center line-46 fonts-300 font-40 my-20 text-white-color">
                <img
                  className="justify-content-center text-center pb-0 px-20 "
                  src={forst}
                  alt="forst"
                />
                <p
                  className={`wp-100 px-50 justify-content-center font-family-condensed text-center line-46 fonts-300 font-40 my-20 text-white-color`}
                >
                  Tech Mahindra Awarded Frost & Sullivan's 2023 Global Enabling
                  Technology Leadership Award for Its Innovative Cognitive AI
                  Field Service Management Solution.
                </p>
                <div className={`buttongroup`}>
                  <div className=" d-flex justify-content-center py-20">
                    <Button
                      textclass="font-16 fonts-500 justify-content-center line-19 font-family-roboto-flex"
                      className="wx-147 hx-40 text-color-success radius-5"
                      text="Download Report"
                      onClick={() =>
                        window.open(
                          "https://www.frost.com/wp-content/uploads/2023/11/TechMahindra-Award-Writeup.pdf"
                        )
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="container d-flex justify-content-center flax-gap-5">
          <button
            onClick={() => setActiveIndex(!activetIndex)}
            className={
              activetIndex
                ? "active mt-n-60 p-1"
                : "banner-slider mt-n-60 ml-10 p-1"
            }
          ></button>
          <button
            onClick={() => setActiveIndex(!activetIndex)}
            className={
              activetIndex
                ? "banner-slider mt-n-60 ml-10 p-1"
                : "active mt-n-60 ml-10 p-1"
            }
          ></button>
        </div>
      </div>
    </>
  );
}
